<div class="component-container">
	<div class="toggle-container" [ngClass]="{'on': _on, 'disabled': disabled}" (click)="toggle()">
		<div class="indicator" [ngClass]="{'on': _on, 'disabled': disabled}">&nbsp;</div>
	</div>
	<div class="text-container">
		<ng-content></ng-content>
	</div>
</div>